function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { zIndex } from "../../../settings";

// eslint-disable-next-line no-shadow
export var PortalType = /*#__PURE__*/function (PortalType) {
  PortalType["MODAL"] = "___modal";
  PortalType["TOOLTIP"] = "___tooltip";
  return PortalType;
}({});
var PortalWrapper = styled.div.withConfig({
  componentId: "sc-s4bw1k-0"
})(["z-index:", ";"], zIndex.ModalOrg);
export default function PortalContainerOrg(_ref) {
  var children = _ref.children,
    portalType = _ref.portalType;
  var portalContentRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  useEffect(function () {
    var portalElement = document.getElementById(portalType);
    if (portalElement) {
      portalContentRef.current = portalElement;
      setIsLoaded(true);
    }
  }, []);
  if (!portalContentRef.current) {
    return null;
  }
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, isLoaded ? /*#__PURE__*/React.createElement(PortalWrapper, null, children) : null), portalContentRef.current);
}